import React from 'react';
import cn from 'classnames';

import css from './ProgressLine.module.scss';

interface Props {
  className?: string;
  percentNumber: number;
  color?: 'blue' | 'red';
}

export const ProgressLine: React.FC<Props> = ({ className, percentNumber, color = '' }) => {
  return (
    <div className={cn(css.progress, className)}>
      <div className={cn(css.currentProgress, css[color])} style={{ width: `${percentNumber}%` }}>
        <div className={css.highlight}></div>
      </div>
    </div>
  );
};
